module.exports = __webpack_public_path__ + "img/MP Portal Banner03.9be0d17d.png";